// Copyright 2020 Cartesi Pte. Ltd.
// Licensed under the Apache License, Version 2.0 (the "License"); you may not use
// this file except in compliance with the License. You may obtain a copy of the
// License at http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software distributed
// under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
// CONDITIONS OF ANY KIND, either express or implied. See the License for the
// specific language governing permissions and limitations under the License.
import { GameConstants } from '@cartesi/creepts-engine';
import enemies from './resources/enemies.json';
import turrets from './resources/turrets.json';
import waves from './resources/waves.json';
export default (map) => {
    // build level object using map and constant values
    return {
        engineVersion: GameConstants.VERSION,
        gameConfig: {
            timeStep: 0,
            runningInClientSide: false,
            enemySpawningDeltaTicks: GameConstants.ENEMY_SPAWNING_DELTA_TICKS,
            credits: GameConstants.INITIAL_CREDITS,
            lifes: GameConstants.INITIAL_LIFES,
            boardSize: map.size,
            enemiesPathCells: map.path,
            plateausCells: map.plateaus
        },
        enemiesData: enemies,
        turretsData: turrets,
        wavesData: waves
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGV2ZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGV2ZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsbUNBQW1DO0FBRW5DLGtGQUFrRjtBQUNsRixnRkFBZ0Y7QUFDaEYsd0RBQXdEO0FBRXhELGtGQUFrRjtBQUNsRiw4RUFBOEU7QUFDOUUsNkVBQTZFO0FBQzdFLDZFQUE2RTtBQUU3RSxPQUFPLEVBQUUsYUFBYSxFQUEwQixNQUFNLHlCQUF5QixDQUFDO0FBRWhGLE9BQU8sT0FBTyxNQUFNLDBCQUEwQixDQUFDO0FBQy9DLE9BQU8sT0FBTyxNQUFNLDBCQUEwQixDQUFDO0FBQy9DLE9BQU8sS0FBSyxNQUFNLHdCQUF3QixDQUFDO0FBRTNDLGVBQWUsQ0FBQyxHQUFjLEVBQWUsRUFBRTtJQUMzQyxtREFBbUQ7SUFDbkQsT0FBTztRQUNILGFBQWEsRUFBRSxhQUFhLENBQUMsT0FBTztRQUNwQyxVQUFVLEVBQUU7WUFDUixRQUFRLEVBQUUsQ0FBQztZQUNYLG1CQUFtQixFQUFFLEtBQUs7WUFDMUIsdUJBQXVCLEVBQUUsYUFBYSxDQUFDLDBCQUEwQjtZQUNqRSxPQUFPLEVBQUUsYUFBYSxDQUFDLGVBQWU7WUFDdEMsS0FBSyxFQUFFLGFBQWEsQ0FBQyxhQUFhO1lBQ2xDLFNBQVMsRUFBRSxHQUFHLENBQUMsSUFBSTtZQUNuQixnQkFBZ0IsRUFBRSxHQUFHLENBQUMsSUFBSTtZQUMxQixhQUFhLEVBQUUsR0FBRyxDQUFDLFFBQVE7U0FDOUI7UUFDRCxXQUFXLEVBQUUsT0FBTztRQUNwQixXQUFXLEVBQUUsT0FBTztRQUNwQixTQUFTLEVBQUUsS0FBSztLQUNuQixDQUFDO0FBQ04sQ0FBQyxDQUFDIn0=